module.exports = __webpack_public_path__ + "img/time.75979b78.svg";